import React from 'react';
import './EstudiosPerfiles.scss';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { SysI_Estudios, SysI_PerfilesEstudios, SysI_Prioridades } from '../../types/types.estudios';
import { useApiConfiguration } from '../../api/api.configuration';
import Button from 'devextreme-react/button';
import { Tooltip } from 'devextreme-react';
import DataGrid, { Column, Button as Butt, Editing, Item as Items, Paging, Toolbar, Popup, Lookup, RequiredRule, DataGridTypes, Selection, Form, SearchPanel, Scrolling } from 'devextreme-react/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { GroupItem, Item } from 'devextreme-react/form';
import { useScreenSize } from '../../utils/media-query';
import { ModalStudysByProfiles } from './Modals/ModalStudysByProfiles';
import { newToast } from '../../components';

const Index = () => {
  const { isMedium, isSmall } = useScreenSize();
  const { getPerfiles, newProfile, setProfile, deleteProfile, getEstudios } = useApiConfiguration();
  const [data, setData] = useState<SysI_PerfilesEstudios[]>([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [IdPerfil, setIdPerfil] = useState(-1);
  const [perfil, setPerfil] = useState('');
  const [estudios, setEstudios] = useState<SysI_Estudios[]>([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const dataGridRef = useRef<DataGrid>(null);

  useEffect(() => {
    getPerfiles().then((res) => {
      setData(res);
    });
  }, []);

   useEffect(() => {
    getEstudios().then((res) => {
      setEstudios(res);
    });
  }, []);

  const customData = useMemo(() => {
    return new CustomStore({
      key: 'Pfe_Id',
      load() {
        return getPerfiles()
          .then((res) => ({
            data: res,
            totalCount: res.totalCount,
            summary: res.summary,
            groupCount: res.groupCount,
          }))
          .catch(() => {
            throw new Error('Error de carga de datos');
          });
      },
      insert: async (values) => {
        return newProfile({ Perfil: values })
          .then((res) => {
            if (res === 105) {
              dataGridRef.current?.instance.refresh();
            }
          })
          .catch(() => {
            throw new Error('Error insertando el Estudio');
          });
      },
      update: (key, values) => {
        return setProfile({ Perfil: values, IdPerfil: key })
          .then((res) => {
            if (res === 107) {
              dataGridRef.current?.instance.refresh();
            }
          })
          .catch(() => {
            throw new Error('Error actualizando el Estudio');
          });
      },
      remove: (key) => {
        return deleteProfile({ IdPerfil: key }).then((res) => {
          if (res === 107) {
            dataGridRef.current?.instance.refresh();
          }
        });
      },
    });
  }, []);

  const customDataSrc = new DataSource({
    store: customData,
    reshapeOnPush: true,
  });

  const handleDetails = useCallback(
    (e) => {
      dataGridRef.current?.instance.refresh();
      const { data }: { data: SysI_PerfilesEstudios } = e.row;
      setIsModalVisible(true);
      setIdPerfil(data.Pfe_Id);
      setPerfil(data.Pfe_Nombre);
    },
    [IdPerfil]
  );

  const handleSelection = useCallback(
    ({ selectedRowsData }: DataGridTypes.SelectionChangedEvent) => {
      const dataGrid = selectedRowsData[0];
      setSelectedRow(dataGrid);
    },
    [IdPerfil]
  );

  const handleDuplicateClick = useCallback((e: any) => {
    const { data }: { data: SysI_PerfilesEstudios } = e.row;
    const { Pfe_Id, ...rest } = data;
    const duplicated = {
      ...rest,
      Pfe_Nombre: `${data.Pfe_Nombre} (Copia)`,
      Pfe_Abreviatura: `${data.Pfe_Abreviatura}1`,
    };
    newProfile({ Perfil: duplicated }).then((res) => {
      if (res === 105) {
        dataGridRef.current?.instance.refresh();
        newToast('SUCCESS', 'Perfil duplicado correctamente', 3);
      }
    });
  }, [newProfile]);

  const handleUpdateData = useCallback(() => {
    getPerfiles().then((res) => {
      setData(res);
    });
  }, []);

  return (
    <div className='view crm-contact-list'>
      <div className='view-wrapper view-wrapper-contact-list'>
        <DataGrid className='grid' ref={dataGridRef} dataSource={customDataSrc} width={'100%'} height='100%' repaintChangesOnly={true} highlightChanges={true} rowAlternationEnabled={true} showColumnLines={true} onSelectionChanged={handleSelection}>
          <Editing mode='popup' allowAdding allowDeleting allowUpdating texts={{ saveRowChanges: 'Guardar', cancelRowChanges: 'Cancelar', deleteRow: 'Eliminar', addRow: 'Agregar' }}>
            <Popup title='INFORMACIÓN PERFIL' width={1200} height={'90%'} fullScreen={isMedium || isSmall} showTitle={true} />
            <Form>
              <GroupItem colCount={1}>
                <Item dataField='Pfe_Nombre' />
                <Item dataField='Pfe_Abreviatura' />
              </GroupItem>
              <GroupItem colCount={1}>
                <Item />
                <GroupItem colCount={2}>
                  <Item dataField='Pfe_Estado' editorType='dxCheckBox' />
                </GroupItem>
                <Item dataField='Pfe_Descripcion' editorType='dxTextArea' editorOptions={{ height: 160 }} />
              </GroupItem>
            </Form>
          </Editing>
          <SearchPanel visible={true} />
          <Scrolling columnRenderingMode='standard' mode='standard' useNative={true} scrollByContent={true} showScrollbar='always' />
          <Paging enabled={false} />
          <Selection mode='single' />
          <Toolbar>
            <Items location='before'>
              <div className='grid-header'>PERFILES</div>
            </Items>
            <Items name='searchPanel' />
            <Item name='addRowButton' />
            <Items location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
              <Button id='RefrecarResult' icon='refresh' text='Refresh' stylingMode='text' onClick={handleUpdateData} />
              <Tooltip target={'#RefrecarResult'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
                Refrescar datos
              </Tooltip>
            </Items>
          </Toolbar>
          <Column caption='ID' allowEditing={false} dataField='Pfe_Id' alignment='center' width={50} />
          <Column caption='PERFIL' allowEditing={true} dataField='Pfe_Nombre' alignment='left'>
            <RequiredRule />
          </Column>
          <Column caption='ABREVIATURA' allowEditing={true} dataField='Pfe_Abreviatura' alignment='center' width={120}>
            <RequiredRule />
          </Column>
          <Column caption='ESTADO' allowEditing={true} dataField='Pfe_Estado' alignment='center' width={90}>
            <RequiredRule />
          </Column>
          <Column caption='DESCRIPCIÓN' dataField='Pfe_Descripcion' visible={false} />
          <Column type='buttons' caption={'ACCIÓN'} width={180}>
            <Butt name='edit' />
            <Butt name='delete' />
            <Butt hint='Configurar' icon='eyeopen' visible={true} disabled={false} onClick={handleDetails} />
            <Butt hint='Duplicar' icon='copy' visible={true} disabled={false} onClick={handleDuplicateClick} />
          </Column>
        </DataGrid>
         {isModalVisible && <ModalStudysByProfiles visible={isModalVisible} setVisible={() => setIsModalVisible(false)} IdPerfil={IdPerfil} Perfil={perfil} Estudios={estudios}  />}
      </div>
    </div>
  );
};

export default Index;
